module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/10.82d1068d.jpg";